/* eslint-disable no-underscore-dangle */
import Promise from 'bluebird';
import { getCldrLocale, setupI18nModel } from '@bingads-webui/i18n-model-setup';

const {
  serverContext = {},
} = window._webpack_app_props || {};

const locale = serverContext.currentLocale || document.documentElement.lang;
const cldrLocale = getCldrLocale(locale);

let webpackI18nPromiseResolve;
window.webpackI18nPromise = new Promise((resolve) => {
  webpackI18nPromiseResolve = resolve;
});

import(/* webpackChunkName: "cldr-[request]" */`@bingads-webui-universal/i18n-cldr-data-modern/locales-simplified/${cldrLocale}.json`)
  .then(setupI18nModel(locale))
  .then(webpackI18nPromiseResolve);
